import React from 'react';
import Chip from 'material-ui/Chip';
import muiThemeable from 'material-ui/styles/muiThemeable';
import user from '../Auth/user';
import compose from '../compose';
import { translate } from 'react-i18next';

class StandTagWithLabel extends React.Component {

  render()  {
    const {t} = this.props;

    return (
      <div style={{fontSize: '16px',
        lineHeight: '24px',
        width: '256px',
        height: '72px',
        position: 'relative',
        backgroundColor: 'transparent',
        fontFamily: 'Roboto,sans-serif',
        transition: 'height 200ms cubic-bezier(0.23, 1, 0.32,1) 0ms'
      }}>
        <label style={{
          color: 'rgba(0, 0, 0, 0.3)',
          position: 'absolute',
          lineHeight: '22px',
          top: '38px',
          transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
          transform: 'scale(0.75) translate(0px, -28px)',
          transformOrigin: 'left top 0px',
          fontFamily: 'Roboto,sans-serif',
          cursor: 'auto'}}
        htmlFor={'chip1'}>
          {t('stand.standTag')}
          <Chip id='chip1' backgroundColor={this.props.muiTheme.palette.primary2Color} labelColor='white' labelStyle={{fontSize: '18px'}} style={{marginTop: '10px'}}>
            {this.props.code}
          </Chip>
        </label>
      </div>
    );
  }
}

const enhance = compose(muiThemeable(), translate(), user);

export default enhance(StandTagWithLabel);



// WEBPACK FOOTER //
// ./src/Stand/StandTagWithLabel.js